const tenantConfigUrl = `${process.env.REACT_APP_ENERGY_DASHBOARD_API_URL}/api/tenant/config`;

export default {
  config: tenantConfigUrl,
};
